import { TpDataObjectTable, TpETLTableColumn } from './interfaces';

type TpDataObjectTableProps = {
  table: TpDataObjectTable;
};

export function renderTable(columns: TpETLTableColumn[]) {
  return (
    <table>
      <thead>
        <tr>
          <td>Identifier</td>
          <td>Data type</td>
          <td>Name</td>
          <td>Description</td>
        </tr>
      </thead>
      <tbody>
        {columns.map((col, idx) => (
          <tr key={`idx_${idx}`}>
            <td>{col.identifier}</td>
            <td>{col.dataType}</td>
            <td>{col.name}</td>
            <td>{col.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function DataObjectTable(props: TpDataObjectTableProps) {
  return renderTable(props.table.columns);
}
